import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { ActiveInactiveFor, KeyValues15, KeyValues3, KeyValues5, LocalService, Paging, BatchEntryDetailsInitialization, BatchEntryInitialization, StatusKeyValues15, StatusWithId, SupplierWrapper, UpadateBatchEntryDetailFor, Wrappers15 } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';

@Injectable({
  providedIn: 'root'
})
export class BatchEntryService {
  private controllerName = service_controllers_methods.batchEntry.controller;
  private methods = service_controllers_methods.batchEntry.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public getBatchEntryInitialization(businessId: string, strId: string): Observable<BatchEntryInitialization> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: strId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBatchEntryInitialization, body);
  }

  public getBatchEntry(strId: string, languageCode?: string): Observable<SupplierWrapper> {
    let body = {
      sel: this.localService.getSelected(languageCode),
      strId: strId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBatchEntry, body);
  }

  public saveBatchEntry(wrapper: KeyValues15): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      wrapper: wrapper
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveBatchEntry, body);
  }

  public getBatchEntries(businessId: string, paging?: Paging, isActive: boolean = true): Observable<Wrappers15> {
    let body = {
      sel: this.localService.getSelected(),
      pag: paging,
      dt: { v1: businessId, v2: isActive ? '1' : '0' } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBatchEntries, body);
  }

  public activeInactiveStatus(strId: string, actionFor: ActiveInactiveFor): Observable<StatusWithId> {
    let body = {
      strId: strId,
      sel: this.localService.getSelected(),
      iActionFor: parseInt(actionFor.toString())
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ActiveInactiveStatus, body);
  }

  public getBatchEntryDetailsInitialization(businessId: string, strId: string): Observable<BatchEntryDetailsInitialization> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: strId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBatchEntryDetailsInitialization, body);
  }

  public getBatchEntryDetails(businessId: string, batchEntryId: string, paging?: Paging, isActive: boolean = true): Observable<Wrappers15> {
    let body = {
      sel: this.localService.getSelected(),
      pag: paging,
      dt: { v1: businessId, v2: isActive ? '1' : '0', v3: batchEntryId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBatchEntryDetails, body);
  }

  public getSearchedProducts(businessId: string, searchKey?: string): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: searchKey } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSearchedProducts, body, false);
  }

  public saveBatchEntryDetail(batchEntryId: string, businessId: string, data: KeyValues15): Observable<StatusKeyValues15> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: batchEntryId, v2: businessId } as KeyValues3,
      data: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveBatchEntryDetail, body);
  }

  public updateBatchEntryDetail(batchEntryDetailId: string, actionFor: UpadateBatchEntryDetailFor, strValue: string): Observable<StatusKeyValues15> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: batchEntryDetailId, v2: strValue } as KeyValues3,
      iActionFor: actionFor
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdateBatchEntryDetail, body);
  }
}
